import React from 'react';
import { CountryWithFlag } from '@tangibleplay/core-ui';

import { StyledFormattedAddress } from './FormattedAddress.styles';

import { FormattedAddressProps } from './FormattedAddress.types';

const FormattedAddress = ({
  address,
  hasCountryHidden = false,
  componentClassname = 'formatted-address',
  customClassnames = '',
  customStyle = '',
}: FormattedAddressProps) => {
  // Check if the field exists and is not empty
  const checkFieldNotEmpty = (field: string) => {
    return field && field.length > 0;
  };

  return (
    <StyledFormattedAddress
      className={`${componentClassname} ${customClassnames}`}
      customStyle={customStyle}
    >
      {checkFieldNotEmpty(address.identity) && (
        <span className={`${componentClassname}__city`}>
          {address.identity}
        </span>
      )}
      {checkFieldNotEmpty(address.address1) && (
        <span
          className={`${componentClassname}__address ${componentClassname}__address1`}
        >
          {address.address1}
        </span>
      )}
      {checkFieldNotEmpty(address.address2) && (
        <span
          className={`${componentClassname}__address ${componentClassname}__address2`}
        >
          {address.address2}
        </span>
      )}
      {checkFieldNotEmpty(address.address3) && (
        <span
          className={`${componentClassname}__address ${componentClassname}__address2`}
        >
          {address.address3}
        </span>
      )}
      {address.country?.code === 'US' ? (
        <span className={`${componentClassname}__city-state-zip`}>
          {`${address.city ? `${address.city}` : ''}${
            address.city && address.state ? ',' : ''
          } ${address.state ? `${address.state}` : ''} ${address.zip}`}
        </span>
      ) : (
        <>
          {checkFieldNotEmpty(address.city) && (
            <span className={`${componentClassname}__city`}>
              {address.city}
            </span>
          )}
          {checkFieldNotEmpty(address.state) && (
            <span className={`${componentClassname}__state`}>
              {address.state}
            </span>
          )}
          {checkFieldNotEmpty(address.zip) && (
            <span className={`${componentClassname}__zip`}>{address.zip}</span>
          )}
        </>
      )}
      {!hasCountryHidden &&
        checkFieldNotEmpty(address.country?.code) &&
        checkFieldNotEmpty(address.country?.name) && (
          <CountryWithFlag
            country={{
              code: address.country.code,
              name: address.country.name,
            }}
          />
        )}
    </StyledFormattedAddress>
  );
};
FormattedAddress.displayName = 'FormattedAddress';

export default FormattedAddress;
